import { render, staticRenderFns } from "./RichTextForm.vue?vue&type=template&id=5c71064e"
import script from "./RichTextForm.vue?vue&type=script&lang=js"
export * from "./RichTextForm.vue?vue&type=script&lang=js"
import style0 from "./RichTextForm.vue?vue&type=style&index=0&id=5c71064e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports